export const GRANT_TYPE = 'client_credentials'

